import IsLoading from "@/components/layouts/IsLoading";
import SetLinks from "@/components/layouts/SetLinks";
import Show from "@/components/layouts/Show";
import InstitutionConfigurationList from "@/components/lists/status/InstitutionConfigurationList";
import InstitutionsContext from "@/contexts/data/InstitutionsContext";
import { ConfigurationInstitutionsTrialCreateLink } from "@/contexts/layouts/LinkContext";
import { Typography } from "@mui/material";
import { FC, useContext } from "react";


const ConfigurationInstitutions: FC = () => {
    const { data: institutions } = useContext(InstitutionsContext);

    const loading = false;
    const validating = false;

    return (
        <>
            <SetLinks 
                createTrialLink={ConfigurationInstitutionsTrialCreateLink} 
                institutionLinkEnabled={false} 
                participantLinkEnabled={false} 
            />
            <IsLoading name="configuration-institutions-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Configuration &mdash; Institutions
                </Typography>
                <InstitutionConfigurationList 
                    data={institutions}
                />
            </Show>
        </>
    )
};

export default ConfigurationInstitutions;